import React from 'react';
import { Link } from 'react-router-dom';
import './EmptyState.css';

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  actionLink?: string;
  compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ message, actionLabel, actionLink, compact }) => (
  <div className={`empty-state-shared${compact ? ' empty-state-compact' : ''}`}>
    <span>{message}</span>
    {actionLabel && actionLink && (
      <Link to={actionLink} className="empty-state-action">{actionLabel}</Link>
    )}
  </div>
);

export default EmptyState;
